<template lang="pug">
.background-baselayer
  template(v-if="frameStore.type == 'ESO_MILKY_WAY'")
    eso-milky-way-layer
  template(v-if="frameStore.hips")
    v-hips-mask-layer(
      v-if="frameStore.hips.mask",
      :baseUrl="frameStore.hips.mask",
      :integerOrder="true")
    v-hips-png-layer(
      :fade="frameStore.fade",
      :baseUrl="frameStore.hips.surface",
      :animationLod="Store.config.hipsLayer.animationLod",
      :lodBias="Store.config.hipsLayer.lodBias",
      :keepCenter="true")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { BackgroundModule } from "@/modules/BackgroundModule";
import { FrameStore } from "@/modules/base";
import { EsoMilkyWayLayer } from '@hscmap/stellar-globe'
import { Layer2Component } from '@/stellar-globe-components';

@Component({
  components: {
    EsoMilkyWayLayer: Layer2Component(EsoMilkyWayLayer),
  },
})
export default class extends Vue {
  @Prop({ required: true })
  frameStore!: FrameStore<typeof BackgroundModule>
}
</script>